import { Link } from 'react-router-dom';

const SAMPLE_SPONSOR = 'Fairway Financial Group';

export default function SponsorStrip() {
  return (
    <section className="bg-foreground-950 border-y border-foreground-800 px-4 md:px-8 py-6 md:py-7">
      <div className="flex flex-col md:flex-row items-center justify-between gap-5">
        <div className="flex flex-col sm:flex-row items-center gap-4 md:gap-6 text-center sm:text-left">
          <span className="font-label uppercase tracking-[0.24em] text-[10px] text-accent-400 font-bold whitespace-nowrap">
            Featured sponsor
          </span>
          <span className="hidden sm:block w-px h-10 bg-foreground-700"></span>
          <div className="flex items-center gap-3">
            <span className="w-11 h-11 rounded-md bg-foreground-800 text-accent-400 flex items-center justify-center text-2xl shrink-0"><i className="ri-award-line"></i></span>
            <div>
              <p className="font-heading font-bold text-background-50 text-xl leading-none">{SAMPLE_SPONSOR}</p>
              <p className="font-label uppercase tracking-widest text-[10px] text-foreground-400 mt-1.5">Sample sponsor — placement example</p>
            </div>
          </div>
        </div>
        <Link
          to="/partners"
          className="inline-flex items-center gap-2 border border-accent-500 text-accent-400 hover:bg-accent-500 hover:text-foreground-950 font-label font-bold uppercase tracking-wider text-sm px-5 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors"
        >
          <span className="w-5 h-5 flex items-center justify-center"><i className="ri-megaphone-line"></i></span>
          Become a sponsor
        </Link>
      </div>
    </section>
  );
}